import { useMutation } from '@tanstack/react-query';
import { errorHandler } from '@app/utils/errorHandler';
import { api } from '@app/utils/api';
import { PANEl_BASE_URL } from '@app/contstants/endpoints';
import { IApplicationReport } from '@entities/application/IApplicationReport';
import { ISelectOption } from '@widgets/multi-select';
import { ERR_BAD_REQUEST } from '@app/contstants/http-codes';
import { ServerError } from '@app/error/ServerError';

export const fetch = async ({
  account,
  is_new,
}: {
  account: string;
  is_new: boolean;
}): Promise<void> => {
  try {
    const res = await api.post(`${PANEl_BASE_URL}/accounts/accounts/${account}/override_is_new/`, {
      override_is_new_date_end: new Date().toISOString().slice(0, 10),
      override_is_new: is_new,
    });
  } catch (e: any) {
    if (e.status === ERR_BAD_REQUEST) {
      throw new ServerError(e.response.data.error);
    }
  }
};

export const useSwitchAccountIsNew = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
